export default "__VITE_ASSET__DiG6HREx__"